import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'projects/merkel_defensePoster.jpg' satisfies MediaPath

export const meta: EntryMeta = {
	slug: 'galaga',
	name: 'Galaga',
	excerpt: 'A recreation of the 1981 NAMCO arcade classic',
	tags: ['code', 'game', 'canvas'],
	cover,
	order: 30,
	repo: 'https://github.com/eam/galaga',
}

export default function Galaga() {
	return (
		<>
			<h2 className="font-bold text-xl mt-0">About</h2>
			<p>
				A from-scratch recreation of the 1981 arcade game — enemy formation AI, dive patterns, the
				tractor-beam capture/rescue mechanic, and scoring — implemented on a single canvas with a
				fixed-timestep loop and a small ECS.
			</p>
			<ul>
				<li>Vanilla TypeScript, no engine</li>
				<li>Sprite atlas + per-frame state machine for enemy behavior</li>
				<li>Deterministic fixed-timestep simulation</li>
			</ul>
			<p>Source and a playable build are linked above.</p>
			<Gallery items={[{ src: cover, alt: 'Title screen' }]} />
		</>
	)
}
